import { useSylveraQuery } from '@sylveraio/react-utils'
import first from 'lodash/first'
import { useState } from 'react'
import { GET_PROJECT_FROM_ID, ProjectsFuzzy } from './GET_PROJECT_FROM_ID'
import type { BuyerFormModalProps } from './types'
import { formatProjectText } from '../utils/formatProjectText'
import { BuyerForm } from '../BuyerForm/BuyerForm'
import type { ValueBase } from 'types'

export function BuyerFormModal({
  onClose,
  isOpen,
  projectPublicId,
  client,
  userId,
  onFAQChange,
  showFaqPreference,
}: BuyerFormModalProps) {
  const [presetProjectId, setPresetProjectId] = useState<ValueBase>()

  useSylveraQuery(GET_PROJECT_FROM_ID, client, {
    variables: {
      publicId: projectPublicId,
    },
    skip: typeof projectPublicId === 'undefined',
    onCompleted: (data?: ProjectsFuzzy) => {
      if (data) {
        const entry: ValueBase | undefined = first(
          (data?.projects?.nodes || []).map(
            ({ publicId, name, projectRegistry }) => {
              const text = formatProjectText(
                name,
                projectRegistry?.registry?.name,
                projectRegistry?.registryProjectId,
              )
              return {
                value: publicId,
                text,
              }
            },
          ),
        )
        if (entry) setPresetProjectId(entry)
      }
    },
  })

  const handleClose = () => {
    setPresetProjectId(undefined)
    onClose()
  }

  if (
    !userId ||
    !isOpen ||
    (typeof projectPublicId !== 'undefined' &&
      typeof presetProjectId === 'undefined')
  )
    return null

  return (
    <BuyerForm
      userId={userId}
      client={client}
      onFAQChange={onFAQChange}
      showFaqPreference={showFaqPreference}
      onClose={handleClose}
      projectId={presetProjectId}
    />
  )
}

export default BuyerFormModal
